const IMAGES = [
    require("./1.webp"),
    require("./2.webp"),
    require("./3.webp"),
    require("./4.webp"),
]

export default IMAGES;
